import { jsx as _jsx } from "react/jsx-runtime";
import { DraftingPane } from '~/components/ai/DraftingPane/DraftingPane';
import { SparkleIcon } from '~/components/ai/shared/SparkleIcon/SparkleIcon';
import { useLocaleKeys } from '~/i18n';
import { BULK_PANE_INTERCOM_VERTICAL_PADDING, bulkPanePosition } from './bulkPaneLayout';
export const BulkPaneShell = (param)=>{
    let { testId, isOpen, conversation, handlers, onSubmitPrompt, clearChatBiName, toggleBiName, onToggle, onExpand } = param;
    const { t } = useLocaleKeys();
    return /*#__PURE__*/ _jsx(DraftingPane, {
        testId: testId,
        isOpen: isOpen,
        position: bulkPanePosition,
        dragResize: true,
        intercom: {
            collapsedVerticalPadding: BULK_PANE_INTERCOM_VERTICAL_PADDING
        },
        header: {
            mode: 'collapsible',
            icon: /*#__PURE__*/ _jsx(SparkleIcon, {}),
            title: t.agenticDrafting.header.bulkTitle(),
            onClearChat: conversation.clear,
            isClearDisabled: conversation.view.isClearDisabled,
            clearChatBiName,
            onToggle,
            onExpand,
            toggleBiName,
            collapseChevronOrientation: 'vertical'
        },
        chat: conversation.chat,
        activeMessage: conversation.view.activeMessage,
        placeholderPool: [],
        onSubmitPrompt: onSubmitPrompt,
        onFileUpload: conversation.onFileUpload,
        onRemoveAttachment: conversation.onRemoveAttachment,
        handlers: handlers
    });
};
